export const WORKSPACE_DASHBOARD_RANGE_DAYS = 7 as const;

export type WorkspaceDashboardDeployBucket = {
  t: string;
  success: number;
  failed: number;
  started: number;
};

export type WorkspaceDashboardTrafficBucket = {
  t: string;
  count: number;
};

export type WorkspaceDashboardCharts = {
  rangeDays: typeof WORKSPACE_DASHBOARD_RANGE_DAYS;
  deployBuckets: WorkspaceDashboardDeployBucket[];
  trafficBuckets: WorkspaceDashboardTrafficBucket[];
  backlog: { queued: number; building: number };
  terminalInRange: { success: number; failed: number };
  successRate: number | null;
};

/** True when the workspace has deployments in range or active backlog worth surfacing. */
export const hasWorkspaceDashboardActivity = (
  charts: WorkspaceDashboardCharts,
): boolean => {
  const { backlog, terminalInRange } = charts;
  if (backlog.queued > 0 || backlog.building > 0) return true;
  return terminalInRange.success > 0 || terminalInRange.failed > 0;
};
